import React from 'react';
import { CheckIcon, MapPinIcon } from 'lucide-react';
import { LinkButton } from './ui/Button';
import { Pill } from './ui/Pill';
import { WhatsAppIcon } from './ui/WhatsAppIcon';
import { OrigenChip } from './origen/OrigenChip';
import { waLink } from '../utils/whatsapp';
const signals = ['Atención personalizada', 'Diagnóstico explicado', 'Respuesta el mismo día'];
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/8e98b241-6bb6-4832-a370-65039e6abc23.jpg';
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-base py-[60px] lg:py-[100px]" data-id="element-98" data-mp="xbpc32nfnudg">
      <div className="mx-auto grid max-w-shell items-center gap-12 px-5 lg:grid-cols-[60fr_40fr] lg:gap-16 lg:px-[120px]" data-id="element-99" data-mp="sa9rtct2xrw4">
        <div data-id="element-100" data-mp="nbygsyr1tbcb">
          <Pill className="!gap-[6px] !text-[12px]" data-id="element-101" data-mp="neav91xll3km">
            Odontología moderna
            <span className="font-bold text-secondary" aria-hidden="true" data-id="element-102" data-mp="3d2tod9lewkej">
              ·
            </span>
            <MapPinIcon className="h-3 w-3 shrink-0 text-secondary" strokeWidth={2} data-id="element-103" data-mp="384jud2bfbpui" />
            Bogotá, Colombia
          </Pill>

          <div className="relative max-w-[520px]" data-id="element-104" data-mp="3o7c0jz1umrh5">
            <h1 className="mt-5 font-display text-[32px] font-bold leading-[1.15] text-ink lg:text-[48px]" data-id="element-105" data-mp="3o6u87dib4xei">
              Cuida tu sonrisa con una atención que te explica todo claramente.
            </h1>
            <OrigenChip order={0} arrow="left" position="left-[calc(100%+20px)] top-1/2 -translate-y-1/2" data-id="element-106" data-mp="3e7l7m1sxskj6">
              Este titular no describe el consultorio. Describe la experiencia del paciente. Reduce la tasa de rebote
              porque conecta emocionalmente antes de informar.
            </OrigenChip>
          </div>

          <p className="mt-5 max-w-[480px] font-sans text-[17px] leading-[1.6] text-muted" data-id="element-107" data-mp="2viy43nqes37p">
            Valoraciones, tratamientos y seguimiento en un consultorio diseñado para que llegues con dudas y te vayas con
            un plan.
          </p>

          <div className="relative mt-8 flex w-full flex-col gap-3 sm:w-fit sm:flex-row" data-id="element-108" data-mp="2ljh0dbupvzed">
            <LinkButton variant="whatsapp" href={waLink('Hola, quisiera agendar una valoración inicial en Sonrisa Clara.')} target="_blank" rel="noreferrer" data-id="element-109" data-mp="s332b5sqsatu">
              <WhatsAppIcon className="h-5 w-5" data-id="element-110" data-mp="ici0zaloos78" />
              Agendar valoración por WhatsApp
            </LinkButton>
            <LinkButton variant="outline" href="#tratamientos" data-id="element-111" data-mp="dbasf9bpvozi">
              Ver tratamientos
            </LinkButton>
          </div>

          <OrigenChip layout="flow" order={1} className="ml-0 mr-auto" data-id="element-112" data-mp="161jc55lwihg7">
            El CTA principal es WhatsApp porque reduce la fricción del primer contacto al mínimo. El paciente usa el
            canal que ya conoce, sin formularios ni esperas. El mensaje prellenado elimina la barrera de «no sé qué
            escribir».
          </OrigenChip>

          <p className="mt-4 font-sans text-[13px] italic text-muted" data-id="element-113" data-mp="3lquhrx99on9a">
            Sin formularios. Te orientamos antes de tu visita.
          </p>

          <ul className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-0" data-id="element-114" data-mp="1xa44lgt9woko">
            {signals.map((signal, index) => <li key={signal} className={`flex items-center gap-2 sm:px-5 ${index > 0 ? 'sm:border-l sm:border-hairline' : 'sm:pl-0'}`} data-id="element-115" data-mp="21b66y6ihlgqv" data-mpi={index}>
                <CheckIcon className="h-4 w-4 shrink-0 text-secondary" strokeWidth={2.5} data-id="element-116" data-mp="2fzsugvi9pet6" />
                <span className="font-sans text-[14px] text-ink" data-id="element-117" data-mp="2g257cu964yzd">{signal}</span>
              </li>)}
          </ul>
        </div>

        <div className="relative" data-id="element-118" data-mp="2p08vzzfgabve">
          <div aria-hidden="true" className="absolute -right-10 -top-12 h-[320px] w-[320px] rounded-[46%_54%_38%_62%/52%_40%_60%_48%] bg-secondary/[0.08]" data-id="element-119" data-mp="2p1a5w0kqcsbj" />
          <div className="relative mx-auto h-[380px] w-full max-w-[480px] overflow-hidden rounded-[20px] lg:h-[520px]" data-id="element-120" data-mp="uo0uu4cjcyr6">
            <img src={HERO_IMAGE} alt="Consultorio odontológico moderno con luz natural, madera clara y plantas" className="h-full w-full object-cover" loading="eager" data-id="element-121" data-mp="znn8ug06uj11" />
          </div>
        </div>
      </div>
    </section>;
}